export class HelperFunctions {
  static getGuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  static compareArrays(array1: any, array2: any) {
    return (
      array1.length === array2.length &&
      array1.sort().every(function (value, index) {
        return value === array2.sort()[index];
      })
    );
  }

  static isGuidEmpty(guid: string) {
    return !guid || guid === "00000000-0000-0000-0000-000000000000";
  }

  static mergeArraysWithoutDuplicates(array1: any, array2: any) {
    return [...new Set([...array1, ...array2])];
  }
}
